exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles__chip-container___1shsb{position:relative;display:flex;flex-flow:row;justify-content:flex-start;width:100%}.styles__chip___1w1ea{position:relative;border-radius:.5rem;width:3rem;height:2.25rem;background:linear-gradient(135deg,#ffb347,#fc3);border:2px solid rgba(44,62,80,.2);margin-left:2rem;z-index:10}", ""]);

// exports
exports.locals = {
	"chip-container": "styles__chip-container___1shsb",
	"chip": "styles__chip___1w1ea"
};